const Settings = {
    navTheme: 'realDark', //'light',
    // 拂晓蓝
    primaryColor: '#1890ff',
    layout: 'mix',
    contentWidth: 'Fluid',
    fixedHeader: false,
    fixSiderbar: true,
    colorWeak: false,
    title: '分型系统',
    pwa: false,
    logo: '/branding/fractalai-mark.svg',
    iconfontUrl: '',
  };
  export default Settings;
